var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { HttpClient, HttpParams, } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { Auth } from '@shared/auth';
import { Observable } from 'rxjs/Observable';
import { catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { isDefined } from './helpers';
var ApiHttp = /** @class */ (function () {
    function ApiHttp(http, errorHandler, auth, datastoreConfig) {
        this.http = http;
        this.errorHandler = errorHandler;
        this.auth = auth;
        this.datastoreConfig = datastoreConfig;
    }
    ApiHttp.prototype.fetch = function (r, query) {
        var _this = this;
        return Observable.of(r).pipe(withLatestFrom(this.auth.getAuthorizationHeader()), switchMap(function (_a) {
            var request = _a[0], authHeader = _a[1];
            var baseUrl = request.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var pagination = {
                limit: query && query.limit,
                offset: query && query.offset,
            };
            // Add webapp=1 for tracking in the backend to API requests
            var requestParams = request.isGaf
                ? request.params || {}
                : __assign({}, (request.params || {}), { webapp: 1 });
            var params = pagination
                ? __assign({ limit: pagination.limit, offset: pagination.offset }, requestParams) : requestParams;
            return _this.http.get(baseUrl + "/" + request.endpoint, {
                headers: authHeader,
                params: _this.serialize(params),
            });
        }), catchError(function (err) {
            if (err.error instanceof Error) {
                // A client-side or network error occurred.
                _this.errorHandler.handleError(err.error);
                // FIXME: not sure why TS can't figure out the typings here
                return Observable.of({
                    status: 'error',
                    message: err.error.message,
                });
            }
            // The backend returned an unsuccessful response code.
            _this.errorHandler.handleError(new Error(err.message));
            // FIXME: not sure why TS can't figure out the typings here
            return Observable.of({
                status: 'error',
                message: err.message,
            });
        }));
    };
    ApiHttp.prototype.post = function (request) {
        return this.mutate(request, { action: 'post', payload: request.payload });
    };
    ApiHttp.prototype.put = function (request) {
        return this.mutate(request, { action: 'put', payload: request.payload });
    };
    ApiHttp.prototype.delete = function (request) {
        return this.mutate(request, { action: 'delete' });
    };
    ApiHttp.prototype.mutate = function (request, data) {
        var _this = this;
        return Observable.of(request).pipe(withLatestFrom(this.auth.getAuthorizationHeader()), switchMap(function (_a) {
            var newRequest = _a[0], authHeader = _a[1];
            var baseUrl = newRequest.isGaf
                ? _this.datastoreConfig.ajaxBaseUrl
                : _this.datastoreConfig.apiBaseUrl;
            var url = baseUrl + "/" + newRequest.endpoint;
            var options = { headers: authHeader };
            if (data.action === 'delete') {
                return _this.http.delete(url, options);
            }
            var body = __assign({}, data.payload, newRequest.params);
            if (data.action === 'post') {
                return _this.http.post(url, 
                // default to JSON
                request.asJSON ? body : _this.serialize(body), options);
            }
            // FIXME, make put support JSON as well.
            return _this.http.put(url, _this.serialize(body), options);
        }));
    };
    ApiHttp.prototype.serialize = function (obj) {
        var params = new HttpParams();
        Object.entries(obj)
            .filter(isDefined)
            .forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (typeof value === 'string') {
                params = params.set(key, value);
            }
            else if (typeof value === 'number') {
                params = params.set(key, String(value));
            }
            else if (Array.isArray(value)) {
                // This type casting shouldn't be necessary but is because of a TS bug.
                // https://github.com/Microsoft/TypeScript/issues/15315
                // https://github.com/Microsoft/TypeScript/issues/7294
                // Our backend expects arrays foo=[1,2] to be encoded as foo[]=1&foo[]=2
                value
                    .filter(isDefined)
                    .forEach(function (rawVal) {
                    // The batching of requests connatenates things with `&`.
                    return String(rawVal)
                        .split('&')
                        .forEach(function (v) { return (params = params.append(key + "[]", v)); });
                });
            }
        });
        params = params.set('compact', 'true');
        return params;
    };
    return ApiHttp;
}());
export { ApiHttp };



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/api-http.service.ts.pre-build-optimizer.js